export default (size = 1) => {
  const base = 8;
  const pxSize = size === 0 ? 1 : size * base;
  return `${pxSize / 16}rem`; // returning in REM
};
